var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F26207",
    d: "M11 8c0-2.122.845-4.157 2.35-5.657A8.037 8.037 0 0 1 19.026 0h37.45a8.04 8.04 0 0 1 5.675 2.343A7.987 7.987 0 0 1 64.5 8v34.667H19.025a8.037 8.037 0 0 1-5.674-2.343A7.987 7.987 0 0 1 11 34.666V8Zm53.5 34.667h45.475a8.04 8.04 0 0 1 5.675 2.343 7.987 7.987 0 0 1 2.35 5.657v26.666a7.987 7.987 0 0 1-2.35 5.657 8.04 8.04 0 0 1-5.675 2.343H64.5V42.667ZM11 93.333c0-2.121.845-4.156 2.35-5.656a8.037 8.037 0 0 1 5.675-2.344H64.5V120a7.987 7.987 0 0 1-2.35 5.657A8.039 8.039 0 0 1 56.475 128h-37.45a8.039 8.039 0 0 1-5.674-2.343A7.987 7.987 0 0 1 11 120V93.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplit);
export default __webpack_public_path__ + "static/media/replit.55af88a7ae240409ea9cc0032409931e.svg";
export { ForwardRef as ReactComponent };